import { createAsyncThunk } from '@reduxjs/toolkit'
import HttpGetService from 'Services/Get/HttpGetService'
import VisitsApiPaths from '../Constants/VisitsApiPaths'
import { IApplicationState } from 'Store/types'
import axios from 'axios'
import {
  failureVehicleVisitingPointUploadFile,
  failureVehicleAccessoryUploadFile,
  failureVideoUploadFile,
  setVehicleVisitingPointCancelToken,
  setVehicleVisitingPointUploadProgress,
  setVehicleAccessoryCancelToken,
  setVehicleAccessoryUploadProgress,
  setVideoCancelToken,
  setVideoUploadProgress,
  successVehicleVisitingPointUploadFile,
  successVehicleAccessoryUploadFile,
  successVideoUploadFile,
  setNotHealthyAutoPartCancelToken,
  setNotHealthyAutoPartUploadProgress,
  successNotHealthyAutoPartUploadFile,
  failureNotHealthyAutoPartUploadFile,
  setDeliberatelyCancelToken,
  setDeliberatelyUploadProgress,
  successDeliberatelyUploadFile,
  failureDeliberatelyUploadFile,
} from './reducer'
import { instance, podInstance } from 'Services/instance'
import showResponseError from 'Utils/showResponseError'
import HttpPostService from 'Services/Post/HttpPostService'
import VisitsPaths from '../Constants/VisitsPaths'
import { IAutoPartModel } from './model'
import { IPlateModel } from 'Components/Plate'
import HttpPutService from 'Services/Put/HttpPutService'
import Const from 'Utils/Consts'
import CacheNames from 'Application/Common/Constants/CacheNames'
import { getCache, setCache } from 'Application/Common/utils'
import { ToastCreateSuccessBottomLeft } from 'Utils/toastService'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import QueryStringBuilder from 'Utils/QueryStringBuilder.Utilts'
import VisitsEndpoints from 'Application/Visits/Constants/VisitsApiPaths'
import { NavigateFunction } from 'react-router-dom'

export const getVisitList = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetVisits',
  async (query, { getState }) => {
    return await HttpGetService({
      url: VisitsApiPaths.GetVisitsPagedFilter,
      params: {
        PlateType:
          query.plate?.type === 'UNDEFINED'
            ? 100
            : query.plate?.type === 'CAR'
              ? 1
              : query.plate?.type === 'FREEZONE'
                ? 3
                : 2,

        PlateCityCode: query.plate?.cityCode
          ? query.plate?.cityCode
          : query.plate?.serialPlate?.value,
        PlateChar: query.plate?.char ? query.plate?.char : null,
        PlateCarSerial: query.plate?.carSerial ? query.plate?.carSerial : null,
        PlateMotorCycleSerial: query.plate?.motorCycleSerial ? query.plate?.motorCycleSerial : null,
        PlateMotorCycleOtherNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : null,

        PlateSerialId: query.plate?.serialPlate?.id,

        PlateAdditionalNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : query.plate?.englishNumber,

        chassisNumber: query.chassisNumber ? query.chassisNumber : null,
        engineNumber: query.engineNumber ? query.engineNumber : null,
        firstName: query.firstName ? query.firstName : null,
        lastName: query.lastName ? query.lastName : null,
        insuranceTypeId: query.insuranceTypeId?.value,
        visitStatus: query.visitStatus,
        visitStartDate: query.visitStartDate,
        visitEndDate: query.visitEndDate,
        pageNumber: query.pageNumber,
        pageSize: query.pageSize,
        needTotalCount: true,
      },
    })
  },
)

export const getDraftVisitList = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetDraftVisits',
  async (query, { getState }) => {
    return await HttpGetService({
      url: VisitsApiPaths.GetDraftVisitPagedFilter,

      params: {
        PlateType:
          query.plate?.type === 'UNDEFINED'
            ? 100
            : query.plate?.type === 'CAR'
              ? 1
              : query.plate?.type === 'FREEZONE'
                ? 3
                : 2,

        PlateCityCode: query.plate?.cityCode
          ? query.plate?.cityCode
          : query.plate?.serialPlate?.value,
        PlateChar: query.plate?.char ? query.plate?.char : null,
        PlateCarSerial: query.plate?.carSerial ? query.plate?.carSerial : null,
        PlateMotorCycleSerial: query.plate?.motorCycleSerial ? query.plate?.motorCycleSerial : null,
        PlateMotorCycleOtherNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : null,

        PlateSerialId: query.plate?.serialPlate?.id,

        PlateAdditionalNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : query.plate?.englishNumber,

        ChassisNumber: query.chassisNumber ? query.chassisNumber : null,
        EngineNumber: query.engineNumber ? query.engineNumber : null,
        FirstName: query.firstName ? query.firstName : null,
        LastName: query.lastName ? query.lastName : null,
        InsuranceTypeId: query.insuranceTypeId?.value,
        AssignedDraftVisitStatus: query.draftVisitStatus?.value,
        RegistrationDateFrom: query.visitStartDate,
        RegistrationDateTo: query.visitEndDate,
        PageNumber: query.pageNumber,
        PageSize: query.pageSize,
        NeedTotalCount: true,
      },
    })
  },
)

export const getVisitItem = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetVisitById',
  async visitId => {
    return await HttpGetService({
      url: VisitsApiPaths.GetVisitById,
      params: {
        visitId,
      },
    })
  },
)

export const getDraftVisitItem = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetDraftVisitById',
  async DraftVisitId => {
    return await HttpGetService({
      url: VisitsApiPaths.GetDraftVisitById,
      params: {
        DraftVisitId,
      },
    })
  },
)

export const getVisitDeliberatelyData = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetVisitDeliberatelyData',
  async visitId => {
    return await HttpGetService({
      url: VisitsApiPaths.GetVisitDeliberatelyData,
      params: {
        visitId,
      },
    })
  },
)

export const getVehicleVisitingPoints = createAsyncThunk(
  'Visits/GetVehicleVisitingPoints',
  async () => {
    var data = await getCache(CacheNames.VehicleVisitingPoints)
    if (data) return data

    let response: any
    await HttpGetService({
      url: VisitsApiPaths.GetVehicleVisitingPoints,
      params: {},
      onResult: (result: any) => {
        response = result.data
      },
    })

    if (response && response.length) {
      await setCache(CacheNames.VehicleVisitingPoints, response)
    }

    return response
  },
)

export const getVehicleOptions = createAsyncThunk('Visits/GetOptions', async () => {
  var data = await getCache(CacheNames.VehicleOptions)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GeVehicleOptions,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleOptions, response)
  }

  return response
})

export const getAllAutoParts = createAsyncThunk('Visits/GetAllAutoParts', async () => {
  var data = await getCache(CacheNames.AutoParts)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllAutoParts,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.AutoParts, response)
  }

  return response
})

export const getAllVehicleAccessories = createAsyncThunk(
  'Visits/GetAllVehicleAccessories',
  async () => {
    var data = await getCache(CacheNames.VehicleAccessories)
    if (data) return data

    let response: any
    await HttpGetService({
      url: VisitsApiPaths.GetAllVehicleAccessories,
      params: {},
      onResult: (result: any) => {
        response = result.data
      },
    })

    if (response && response.length) {
      await setCache(CacheNames.VehicleAccessories, response)
    }

    return response
  },
)

export const getAllVehicleTypes = createAsyncThunk('Visits/GetAllVehicleTypes', async () => {
  var data = await getCache(CacheNames.VehicleTypes)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllVehicleTypes,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleTypes, response)
  }

  return response
})

export const getAllVehicleUsages = createAsyncThunk('Visits/GetAllVehicleUsages', async () => {
  var data = await getCache(CacheNames.VehicleUsages)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllVehicleUsages,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleUsages, response)
  }

  return response
})

export const getAllVehicleBrands = createAsyncThunk('Visits/GetAllVehicleBrands', async () => {
  var data = await getCache(CacheNames.VehicleBrands)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllVehicleBrands,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleBrands, response)
  }

  return response
})

export const getAllVehicleTips = createAsyncThunk('Visits/GetAllVehicleTips', async () => {
  var data = await getCache(CacheNames.VehicleTips)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllVehicleTips,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleTips, response)
  }

  return response
})

export const getAllVehicleColors = createAsyncThunk('Visits/GetAllVehicleColors', async () => {
  var data = await getCache(CacheNames.VehicleColors)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllVehicleColors,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.VehicleColors, response)
  }

  return response
})

export const getAllStates = createAsyncThunk('Visits/GetAllStates', async () => {
  var data = await getCache(CacheNames.States)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllStates,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.States, response)
  }

  return response
})

export const getAllCities = createAsyncThunk('Visits/GetAllCities', async () => {
  var data = await getCache(CacheNames.Cities)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllCities,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.Cities, response)
  }

  return response
})

export const getCarPriceEstimator = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetCarPriceEstimator',
  async ({ getState }) => {
    return { min_Price: 3500000000, max_Price: 4000000000 }
    return await HttpGetService({
      url: VisitsApiPaths.GetCarPriceEstimator,
      params: {},
    })
  },
)

export const getEstimatedPriceOfBodyInsurance = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/GetEstimatedPriceOfBodyInsurance', async ({ getState }) => {
  return 3500000000
  return await HttpGetService({
    url: VisitsApiPaths.GetEstimatedPriceOfBodyInsurance,
    params: {},
  })
})
// export const getLicensePlateInquiry = createAsyncThunk<
//   any,
//   IPlateModel,
//   { state: IApplicationState }
// >("Visits/GetLicensePlateInquiry", async (plate, { getState }) => {
//   let response: any;
//   await HttpPostService({
//     url: VisitsApiPaths.GetLicensePlateInquiry,
//     body:
//       plate.type == "CAR"
//         ? {
//             licensePlateNumber: `${plate.carOtherNumber}${plate.char}${plate.carSerial}`,
//             plateNumberSeries: plate.cityCode,
//           }
//         : {
//             licensePlateNumberMotorCycle: plate.plateAdditionalNumber,
//             plateNumberSeries: plate.motorCycleSerial,
//           },
//     onResult: (result: any) => {
//       response = result.data;
//     },
//   });
// });

export const getLicensePlateInquiry = createAsyncThunk<
  any,
  IPlateModel,
  { state: IApplicationState }
>('Visits/GetLicensePlateInquiry', async (plate, { getState }) => {
  let response: any
  await HttpPostService({
    url: VisitsApiPaths.GetLicensePlateInquiry,
    body:
      plate.type == 'CAR'
        ? {
            licensePlateNumber: `${plate.carOtherNumber}${plate.char}${plate.carSerial}`,
            plateNumberSeries: plate.cityCode,
          }
        : {
            licensePlateNumberMotorCycle: plate.motorCycleOtherNumber,
            plateNumberSeries: plate.motorCycleSerial,
          },
    onResult: (result: any) => {
      response = result.data
    },
  })

  return { plate: plate, data: response }
})

function base64ToBlob(base64: string, mime: any) {
  mime = mime || ''
  // strip data URL prefix if present, e.g. "data:image/jpeg;base64,"
  const base64Data = base64.includes(',') ? base64.split(',')[1] : base64
  var sliceSize = 1024
  var byteChars = atob(base64Data)
  var byteArrays = []

  for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
    var slice = byteChars.slice(offset, offset + sliceSize)

    var byteNumbers = new Array(slice.length)
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    var byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: mime })
}

export const uploadVehicleVisitingPointFiles = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/UploadFile', async (command, { getState, dispatch }) => {
  const files = getState().visits.newVisit.vehicleVisitingPoints.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        console.log('imageBlob')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('FileData', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(
          setVehicleVisitingPointCancelToken({
            id: file.id,
            cancelToken: source,
          }),
        )
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setVehicleVisitingPointUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        await instance
          .post(VisitsApiPaths.UploadVisitFile, formData, config)
          .then(res => {
            if (res.status == 200 || res.status == 201) {
              dispatch(
                successVehicleVisitingPointUploadFile({
                  id: file.id,
                  fileId: res.data,
                }),
              )
              return res.data
            } else dispatch(failureVehicleVisitingPointUploadFile(file.id))
          })
          .catch(error => {
            if (
              getState().visits.newVisit.vehicleVisitingPoints.data.length &&
              getState().visits.newVisit.vehicleVisitingPoints.data.find(
                (x: any) => x.id == file.id,
              )?.status != 3
            )
              dispatch(failureVehicleVisitingPointUploadFile(file.id))
          })
      }
    }
    dispatch(uploadVideoFile(command))
    return 1
  } catch (error) {
    console.error(error)
  }
})

export const uploadVideoFile = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/UploadVideoFile',
  async (command, { getState, dispatch }) => {
    const { handleNext, videoFormat } = command
    try {
      if (getState().visits.newVisit.vehicleVisitingPoints.skipVideo && handleNext) {
        handleNext()
        return 1
      }
      const file = getState().visits.newVisit.vehicleVisitingPoints.recordedChunks
      if (file && getState().visits.newVisit.vehicleVisitingPoints.videoStatus != 1) {
        const videoBlob = new Blob(file, { type: videoFormat })

        let formData = new FormData()
        formData.append('FileData', videoBlob, `video.${String(videoFormat).split('/')[1]}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setVideoCancelToken(source))
        let config = {
          timeout: 2000000,
          cancelToken: source.token,
          maxBodyLength: Infinity,
          headers: {
            'Content-Type': 'multipart/form-data',
            Connection: 'keep-alive',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(setVideoUploadProgress(percentageProgress))
          },
        }
        await instance
          .post(VisitsApiPaths.UploadVisitBigFile, formData, config)
          .then(res => {
            if (res.status == 200 || res.status == 201) {
              dispatch(successVideoUploadFile(res.data))
              return res.data
            } else dispatch(failureVideoUploadFile())
          })
          .catch(error => {
            dispatch(failureVideoUploadFile())
          })
      }
      if (
        !(
          getState().visits.newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) ||
          getState().visits.newVisit.vehicleVisitingPoints.videoStatus != 1
        ) &&
        handleNext
      )
        handleNext()
      return 1
    } catch (error) {
      console.error(error)
    }
  },
)

export const uploadDeliberateliesFiles = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/uploadDeliberateliesFiles',
  async (command, { getState, dispatch }) => {
    const { handleNext, visitId, navigate } = command
    let files: IAutoPartModel[] = []
    if (
      getState().visits.newVisit.customerDeliberately.nationalCard &&
      getState().visits.newVisit.customerDeliberately.nationalCard?.status != 1
    )
      files.push(getState().visits.newVisit.customerDeliberately.nationalCard as IAutoPartModel)
    if (
      getState().visits.newVisit.customerDeliberately.nationalCardBack &&
      getState().visits.newVisit.customerDeliberately.nationalCardBack?.status != 1
    )
      files.push(getState().visits.newVisit.customerDeliberately.nationalCardBack as IAutoPartModel)
    if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD') {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCard &&
        getState().visits.newVisit.customerDeliberately.vehicleCard?.status != 1
      )
        files.push(getState().visits.newVisit.customerDeliberately.vehicleCard as IAutoPartModel)
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCardBack &&
        getState().visits.newVisit.customerDeliberately.vehicleCardBack?.status != 1
      )
        files.push(
          getState().visits.newVisit.customerDeliberately.vehicleCardBack as IAutoPartModel,
        )
    } else if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC') {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleDoc &&
        getState().visits.newVisit.customerDeliberately.vehicleDoc?.status != 1
      )
        files.push(getState().visits.newVisit.customerDeliberately.vehicleDoc as IAutoPartModel)
    } else {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc &&
        getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.status != 1
      )
        files.push(
          getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc as IAutoPartModel,
        )
    }
    try {
      if (files) {
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          let image = file.image.replace(`data:${file.fileType};base64,`, '')
          const imageBlob = base64ToBlob(image, file.fileType)

          let formData = new FormData()
          formData.append('FileData', imageBlob, `image.${file.fileType.replace('image/', '')}`)
          const CancelToken = axios.CancelToken
          const source = CancelToken.source()
          dispatch(setDeliberatelyCancelToken({ id: file.id, cancelToken: source }))
          let config = {
            timeout: 120000,
            cancelToken: source.token,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progress: any) => {
              const { loaded, total } = progress
              const percentageProgress = Math.floor((loaded / total) * 100)
              dispatch(
                setDeliberatelyUploadProgress({
                  id: file.id,
                  progress: percentageProgress,
                }),
              )
            },
          }
          await instance
            .post(VisitsApiPaths.UploadVisitFile, formData, config)
            .then(res => {
              if (res.status == 200 || res.status == 201) {
                dispatch(
                  successDeliberatelyUploadFile({
                    id: file.id,
                    fileId: res.data,
                  }),
                )
                return res.data
              } else dispatch(failureDeliberatelyUploadFile(file.id))
            })
            .catch(error => {
              // if (getState().visits.newVisit.vehicleVisitingPoints.data.length && getState().visits.newVisit.vehicleVisitingPoints.data.find((x: any) => x.id == file.id)?.status != 3)
              dispatch(failureDeliberatelyUploadFile(file.id))
            })
        }
      }

      let newFiles: IAutoPartModel[] = []
      if (
        getState().visits.newVisit.customerDeliberately.nationalCard &&
        getState().visits.newVisit.customerDeliberately.nationalCard?.status != 1
      )
        newFiles.push(
          getState().visits.newVisit.customerDeliberately.nationalCard as IAutoPartModel,
        )
      if (
        getState().visits.newVisit.customerDeliberately.nationalCardBack &&
        getState().visits.newVisit.customerDeliberately.nationalCardBack?.status != 1
      )
        newFiles.push(
          getState().visits.newVisit.customerDeliberately.nationalCardBack as IAutoPartModel,
        )
      if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD') {
        if (
          getState().visits.newVisit.customerDeliberately.vehicleCard &&
          getState().visits.newVisit.customerDeliberately.vehicleCard?.status != 1
        )
          newFiles.push(
            getState().visits.newVisit.customerDeliberately.vehicleCard as IAutoPartModel,
          )
        if (
          getState().visits.newVisit.customerDeliberately.vehicleCardBack &&
          getState().visits.newVisit.customerDeliberately.vehicleCardBack?.status != 1
        )
          newFiles.push(
            getState().visits.newVisit.customerDeliberately.vehicleCardBack as IAutoPartModel,
          )
      } else if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC') {
        if (
          getState().visits.newVisit.customerDeliberately.vehicleDoc &&
          getState().visits.newVisit.customerDeliberately.vehicleDoc?.status != 1
        )
          newFiles.push(
            getState().visits.newVisit.customerDeliberately.vehicleDoc as IAutoPartModel,
          )
      } else {
        if (
          getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc &&
          getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.status != 1
        )
          newFiles.push(
            getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc as IAutoPartModel,
          )
      }
      if (newFiles.length == 0) {
        if (handleNext) {
          handleNext()
          return 1
        } else {
          dispatch(
            completePendingVisit({
              data: {
                visitId: visitId,
                nationalCardId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.nationalCard?.fileId,
                nationalCardHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFile
                    : null,
                nationalCardHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFileType
                    : null,
                nationalCardHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCard
                        ?.hashFileExtension
                    : null,
                nationalCardHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFileSize
                    : null,
                nationalCardBackId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.nationalCardBack?.fileId,
                nationalCardBackHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFile
                    : null,
                nationalCardBackHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFileType
                    : null,
                nationalCardBackHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCardBack
                        ?.hashFileExtension
                    : null,
                nationalCardBackHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFileSize
                    : null,
                vehicleDeliberatelyType:
                  getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                    ? 1
                    : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                        'DOC'
                      ? 2
                      : 3,
                vehicleCardId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                        'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCard?.fileId
                      : null,
                vehicleCardHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFile
                      : null
                    : null,
                vehicleCardHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFileType
                      : null
                    : null,
                vehicleCardHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCard
                          ?.hashFileExtension
                      : null
                    : null,
                vehicleCardHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFileSize
                      : null
                    : null,
                vehicleCardBackId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                        'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.fileId
                      : null,
                vehicleCardBackHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.hashFile
                      : null
                    : null,
                vehicleCardBackHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCardBack
                          ?.hashFileType
                      : null
                    : null,
                vehicleCardBackHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCardBack
                          ?.hashFileExtension
                      : null
                    : null,
                vehicleCardBackHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCardBack
                          ?.hashFileSize
                      : null
                    : null,
                vehicleDocId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                        'DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.fileId
                      : null,
                vehicleDocHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFile
                      : null
                    : null,
                vehicleDocHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFileType
                      : null
                    : null,
                vehicleDocHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleDoc
                          ?.hashFileExtension
                      : null
                    : null,
                vehicleDocHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFileSize
                      : null
                    : null,
                vehicleCompanyDocId:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? null
                    : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                        'COMPANY_DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.fileId
                      : null,
                vehicleCompanyDocHashFile:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'COMPANY_DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile
                      : null
                    : null,
                vehicleCompanyDocHashFileType:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'COMPANY_DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                          ?.hashFileType
                      : null
                    : null,
                vehicleCompanyDocHashFileExtension:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'COMPANY_DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                          ?.hashFileExtension
                      : null
                    : null,
                vehicleCompanyDocHashFileSize:
                  getState().visits.newVisit.storeFileType == 'POD_SPACE'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'COMPANY_DOC'
                      ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                          ?.hashFileSize
                      : null
                    : null,
              },
              navigate,
            }),
          )
          return 2
        }
      }
      return 0
    } catch (error) {
      showResponseError(error)
    }
  },
)

export const uploadNotHealthyAutoPartsFiles = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/uploadNotHealthyAutoPartsFiles', async (handleNext, { getState, dispatch }) => {
  const files = getState().visits.newVisit.notHealthyAutoParts.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('FileData', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(
          setNotHealthyAutoPartCancelToken({
            id: file.id,
            cancelToken: source,
          }),
        )
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setNotHealthyAutoPartUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        await instance
          .post(VisitsApiPaths.UploadVisitFile, formData, config)
          .then(res => {
            if (res.status == 200 || res.status == 201) {
              dispatch(
                successNotHealthyAutoPartUploadFile({
                  id: file.id,
                  fileId: res.data,
                }),
              )
              return res.data
            } else dispatch(failureNotHealthyAutoPartUploadFile(file.id))
          })
          .catch(error => {
            if (
              getState().visits.newVisit.vehicleVisitingPoints.data.length &&
              getState().visits.newVisit.vehicleVisitingPoints.data.find(
                (x: any) => x.id == file.id,
              )?.status != 3
            )
              dispatch(failureNotHealthyAutoPartUploadFile(file.id))
          })
      }
    }
    if (!getState().visits.newVisit.notHealthyAutoParts.data.some(x => x.status != 1) && handleNext)
      handleNext()
    return 1
  } catch (error) {
    console.error(error)
  }
})

export const uploadVehicleAccessoriesFiles = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/uploadVehicleAccessoriesFiles', async (handleNext, { getState, dispatch }) => {
  const files = getState().visits.newVisit.vehicleAccessories.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('FileData', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setVehicleAccessoryCancelToken({ id: file.id, cancelToken: source }))
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setVehicleAccessoryUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        await instance
          .post(VisitsApiPaths.UploadVisitFile, formData, config)
          .then(res => {
            if (res.status == 200 || res.status == 201) {
              dispatch(
                successVehicleAccessoryUploadFile({
                  id: file.id,
                  fileId: res.data,
                }),
              )
              return res.data
            } else dispatch(failureVehicleAccessoryUploadFile(file.id))
          })
          .catch(error => {
            if (
              getState().visits.newVisit.vehicleVisitingPoints.data.length &&
              getState().visits.newVisit.vehicleVisitingPoints.data.find(
                (x: any) => x.id == file.id,
              )?.status != 3
            )
              dispatch(failureVehicleAccessoryUploadFile(file.id))
          })
      }
    }
    if (!getState().visits.newVisit.vehicleAccessories.data.some(x => x.status != 1) && handleNext)
      handleNext()
    return 1
  } catch (error) {
    console.error(error)
  }
})

//----------------------------------------------------------------------------------------------------

export const getUploadLink = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/GetUploadLink',
  async (command, { getState, dispatch }) => {
    const { data } = command

    const sizeInKB = data.sizeInKB == 0 || !data.sizeInKB ? 10200 : data.sizeInKB
    let uploadLink: any
    let isNewUploadLink: boolean = false
    if (Const.env.REACT_APP_POD_SPACE_ONE_UPLOAD_LINK) {
      const lastGetTime = getState().visits?.newVisit?.uploadLink?.lastLinkGetTime
      const nowTime = new Date().getTime()
      if (
        lastGetTime &&
        nowTime - new Date(String(lastGetTime)).getTime() <
          Const.env.REACT_APP_VISIT_CACHE_EXPIRE_TIME_IN_SECONDS * 1000
      ) {
        uploadLink = getState().visits.newVisit.uploadLink.link
      } else {
        await HttpGetService({
          url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${sizeInKB}&VisitId=${data.visitId}`,
          onResult: (result: any) => {
            uploadLink = result.data
            isNewUploadLink = true
          },
        })
      }

      if (uploadLink) {
        if (data.type == 1)
          dispatch(
            uploadDeliberateliesFilesPodSpace({
              ...command,
              uploadLink: uploadLink,
            }),
          )
        else if (data.type == 2)
          dispatch(
            uploadVehicleVisitingPointFilesPodSpace({
              ...command,
              uploadLink: uploadLink,
            }),
          )
        else if (data.type == 3)
          dispatch(
            uploadNotHealthyAutoPartsFilesPodSpace({
              ...command,
              uploadLink: uploadLink,
            }),
          )
        else if (data.type == 4)
          dispatch(
            uploadVehicleAccessoriesFilesPodSpace({
              ...command,
              uploadLink: uploadLink,
            }),
          )
      }
    } else {
      if (data.type == 1)
        dispatch(
          uploadDeliberateliesFilesPodSpace({
            ...command,
            uploadLink: 'NEW_UPLOAD_LINK',
          }),
        )
      else if (data.type == 2)
        dispatch(
          uploadVehicleVisitingPointFilesPodSpace({
            ...command,
            uploadLink: 'NEW_UPLOAD_LINK',
          }),
        )
      else if (data.type == 3)
        dispatch(
          uploadNotHealthyAutoPartsFilesPodSpace({
            ...command,
            uploadLink: 'NEW_UPLOAD_LINK',
          }),
        )
      else if (data.type == 4)
        dispatch(
          uploadVehicleAccessoriesFilesPodSpace({
            ...command,
            uploadLink: 'NEW_UPLOAD_LINK',
          }),
        )
    }
    return { uploadLink, isNewUploadLink }
  },
)

export const uploadVehicleVisitingPointFilesPodSpace = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/UploadFilePodSpace', async (command, { getState, dispatch }) => {
  const { handleNext, data, videoFormat, uploadLink } = command
  const files = getState().visits.newVisit.vehicleVisitingPoints.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('file', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(
          setVehicleVisitingPointCancelToken({
            id: file.id,
            cancelToken: source,
          }),
        )
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'application/json',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setVehicleVisitingPointUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        let newUploadLink = uploadLink
        if (newUploadLink == 'NEW_UPLOAD_LINK') {
          await HttpGetService({
            url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${command.data.sizeInKB}&VisitId=${command.data.visitId}`,
            onResult: (result: any) => {
              newUploadLink = result.data
            },
          })
        }

        if (newUploadLink != 'NEW_UPLOAD_LINK') {
          await podInstance
            .post(`/files/${newUploadLink}`, formData, config)
            .then(res => {
              if (res.status == 200 && res.data.status == 200) {
                dispatch(
                  successVehicleVisitingPointUploadFile({
                    id: file.id,
                    hashFile: res.data?.result?.hash,
                    hashFileType: res.data?.result?.type,
                    hashFileExtension: res.data?.result?.extension,
                    hashFileSize: res.data?.result?.size,
                  }),
                )
                return res.data
              } else dispatch(failureVehicleVisitingPointUploadFile(file.id))
            })
            .catch(error => {
              if (
                getState().visits.newVisit.vehicleVisitingPoints.data.length &&
                getState().visits.newVisit.vehicleVisitingPoints.data.find(
                  (x: any) => x.id == file.id,
                )?.status != 3
              )
                dispatch(failureVehicleVisitingPointUploadFile(file.id))
            })
        }
      }
    }
    dispatch(uploadVideoFilePodSpace({ handleNext, data, videoFormat, uploadLink }))
    return 1
  } catch (error) {
    console.error(error)
  }
})

export const uploadVideoFilePodSpace = createAsyncThunk<any, any, { state: IApplicationState }>(
  'Visits/UploadVideoFilePodSpace',
  async (command, { getState, dispatch }) => {
    const { handleNext, videoFormat, uploadLink } = command
    try {
      if (getState().visits.newVisit.vehicleVisitingPoints.skipVideo && handleNext) {
        handleNext()
        return 1
      }

      const file = getState().visits.newVisit.vehicleVisitingPoints.recordedChunks
      if (file && getState().visits.newVisit.vehicleVisitingPoints.videoStatus != 1) {
        const videoBlob = new Blob(file, { type: videoFormat })

        let formData = new FormData()
        formData.append('file', videoBlob, `video.${String(videoFormat).split('/')[1]}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setVideoCancelToken(source))
        let config = {
          timeout: 2000000,
          cancelToken: source.token,
          maxBodyLength: Infinity,
          headers: {
            'Content-Type': 'application/json',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(setVideoUploadProgress(percentageProgress))
          },
        }
        let newUploadLink = uploadLink
        if (newUploadLink == 'NEW_UPLOAD_LINK') {
          await HttpGetService({
            url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${command.data.sizeInKB}&VisitId=${command.data.visitId}`,
            onResult: (result: any) => {
              newUploadLink = result.data
            },
          })
        }
        if (newUploadLink != 'NEW_UPLOAD_LINK')
          await podInstance
            .post(`/files/${newUploadLink}`, formData, config)
            .then(res => {
              if (res.status == 200 && res.data.status == 200) {
                dispatch(
                  successVideoUploadFile({
                    hashFile: res.data?.result?.hash,
                    hashFileType: res.data?.result?.type,
                    hashFileExtension: res.data?.result?.extension,
                    hashFileSize: res.data?.result?.size,
                  }),
                )
                return res.data
              } else dispatch(failureVideoUploadFile())
            })
            .catch(error => {
              dispatch(failureVideoUploadFile())
            })
      }
      if (
        !(
          getState().visits.newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) ||
          getState().visits.newVisit.vehicleVisitingPoints.videoStatus != 1
        ) &&
        handleNext
      )
        handleNext()
      return 1
    } catch (error) {
      console.error(error)
    }
  },
)

export const uploadDeliberateliesFilesPodSpace = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/uploadDeliberateliesFilesPodSpace', async (command, { getState, dispatch }) => {
  const { handleNext, visitId, navigate, uploadLink } = command
  let files: IAutoPartModel[] = []
  if (
    getState().visits.newVisit.customerDeliberately.nationalCard &&
    getState().visits.newVisit.customerDeliberately.nationalCard?.status != 1
  )
    files.push(getState().visits.newVisit.customerDeliberately.nationalCard as IAutoPartModel)
  if (
    getState().visits.newVisit.customerDeliberately.nationalCardBack &&
    getState().visits.newVisit.customerDeliberately.nationalCardBack?.status != 1
  )
    files.push(getState().visits.newVisit.customerDeliberately.nationalCardBack as IAutoPartModel)
  if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD') {
    if (
      getState().visits.newVisit.customerDeliberately.vehicleCard &&
      getState().visits.newVisit.customerDeliberately.vehicleCard?.status != 1
    )
      files.push(getState().visits.newVisit.customerDeliberately.vehicleCard as IAutoPartModel)
    if (
      getState().visits.newVisit.customerDeliberately.vehicleCardBack &&
      getState().visits.newVisit.customerDeliberately.vehicleCardBack?.status != 1
    )
      files.push(getState().visits.newVisit.customerDeliberately.vehicleCardBack as IAutoPartModel)
  } else if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC') {
    if (
      getState().visits.newVisit.customerDeliberately.vehicleDoc &&
      getState().visits.newVisit.customerDeliberately.vehicleDoc?.status != 1
    )
      files.push(getState().visits.newVisit.customerDeliberately.vehicleDoc as IAutoPartModel)
  } else {
    if (
      getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc &&
      getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.status != 1
    )
      files.push(
        getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc as IAutoPartModel,
      )
  }
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('file', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setDeliberatelyCancelToken({ id: file.id, cancelToken: source }))
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'application/json',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setDeliberatelyUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        let newUploadLink = uploadLink
        console.log(uploadLink)

        if (newUploadLink == 'NEW_UPLOAD_LINK') {
          await HttpGetService({
            url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${command.data.sizeInKB}&VisitId=${command.data.visitId}`,
            onResult: (result: any) => {
              newUploadLink = result.data
            },
          })
        }
        if (newUploadLink != 'NEW_UPLOAD_LINK')
          await podInstance
            .post(`/files/${newUploadLink}`, formData, config)
            .then(res => {
              if (res.status == 200 && res.data.status == 200) {
                dispatch(
                  successDeliberatelyUploadFile({
                    id: file.id,
                    hashFile: res.data?.result?.hash,
                    hashFileType: res.data?.result?.type,
                    hashFileExtension: res.data?.result?.extension,
                    hashFileSize: res.data?.result?.size,
                  }),
                )
                return res.data
              } else dispatch(failureDeliberatelyUploadFile(file.id))
            })
            .catch(error => {
              // if (getState().visits.newVisit.vehicleVisitingPoints.data.length && getState().visits.newVisit.vehicleVisitingPoints.data.find((x: any) => x.id == file.id)?.status != 3)
              dispatch(failureDeliberatelyUploadFile(file.id))
              console.error(error)
            })
      }
    }

    let newFiles: IAutoPartModel[] = []
    if (
      getState().visits.newVisit.customerDeliberately.nationalCard &&
      getState().visits.newVisit.customerDeliberately.nationalCard?.status != 1
    )
      newFiles.push(getState().visits.newVisit.customerDeliberately.nationalCard as IAutoPartModel)
    if (
      getState().visits.newVisit.customerDeliberately.nationalCardBack &&
      getState().visits.newVisit.customerDeliberately.nationalCardBack?.status != 1
    )
      newFiles.push(
        getState().visits.newVisit.customerDeliberately.nationalCardBack as IAutoPartModel,
      )
    if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD') {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCard &&
        getState().visits.newVisit.customerDeliberately.vehicleCard?.status != 1
      )
        newFiles.push(getState().visits.newVisit.customerDeliberately.vehicleCard as IAutoPartModel)
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCardBack &&
        getState().visits.newVisit.customerDeliberately.vehicleCardBack?.status != 1
      )
        newFiles.push(
          getState().visits.newVisit.customerDeliberately.vehicleCardBack as IAutoPartModel,
        )
    } else if (getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC') {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleDoc &&
        getState().visits.newVisit.customerDeliberately.vehicleDoc?.status != 1
      )
        newFiles.push(getState().visits.newVisit.customerDeliberately.vehicleDoc as IAutoPartModel)
    } else {
      if (
        getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc &&
        getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.status != 1
      )
        newFiles.push(
          getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc as IAutoPartModel,
        )
    }
    if (newFiles.length == 0) {
      if (handleNext) {
        handleNext()
        return 1
      } else {
        dispatch(
          completePendingVisit({
            data: {
              visitId: visitId,
              nationalCardId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.nationalCard?.fileId,
              nationalCardHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFile
                  : null,
              nationalCardHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFileType
                  : null,
              nationalCardHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFileExtension
                  : null,
              nationalCardHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCard?.hashFileSize
                  : null,
              nationalCardBackId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.nationalCardBack?.fileId,
              nationalCardBackHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFile
                  : null,
              nationalCardBackHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFileType
                  : null,
              nationalCardBackHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCardBack
                      ?.hashFileExtension
                  : null,
              nationalCardBackHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.nationalCardBack?.hashFileSize
                  : null,
              vehicleDeliberatelyType:
                getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? 1
                  : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? 2
                    : 3,
              vehicleCardId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCard?.fileId
                    : null,
              vehicleCardHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFile
                    : null
                  : null,
              vehicleCardHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFileType
                    : null
                  : null,
              vehicleCardHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFileExtension
                    : null
                  : null,
              vehicleCardHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCard?.hashFileSize
                    : null
                  : null,
              vehicleCardBackId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.fileId
                    : null,
              vehicleCardBackHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.hashFile
                    : null
                  : null,
              vehicleCardBackHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.hashFileType
                    : null
                  : null,
              vehicleCardBackHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCardBack
                        ?.hashFileExtension
                    : null
                  : null,
              vehicleCardBackHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'CARD'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCardBack?.hashFileSize
                    : null
                  : null,
              vehicleDocId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.fileId
                    : null,
              vehicleDocHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFile
                    : null
                  : null,
              vehicleDocHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFileType
                    : null
                  : null,
              vehicleDocHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFileExtension
                    : null
                  : null,
              vehicleDocHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleDoc?.hashFileSize
                    : null
                  : null,
              vehicleCompanyDocId:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? null
                  : getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                      'COMPANY_DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.fileId
                    : null,
              vehicleCompanyDocHashFile:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'COMPANY_DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile
                    : null
                  : null,
              vehicleCompanyDocHashFileType:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'COMPANY_DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                        ?.hashFileType
                    : null
                  : null,
              vehicleCompanyDocHashFileExtension:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'COMPANY_DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                        ?.hashFileExtension
                    : null
                  : null,
              vehicleCompanyDocHashFileSize:
                getState().visits.newVisit.storeFileType == 'POD_SPACE'
                  ? getState().visits.newVisit.customerDeliberately.vehicleDeliberatelyType ==
                    'COMPANY_DOC'
                    ? getState().visits.newVisit.customerDeliberately.vehicleCompanyDoc
                        ?.hashFileSize
                    : null
                  : null,
            },
            navigate,
          }),
        )
        return 2
      }
    }
    return 0
  } catch (error) {
    console.error(error)
  }
})

export const uploadNotHealthyAutoPartsFilesPodSpace = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/uploadNotHealthyAutoPartsFilesPodSpace', async (command, { getState, dispatch }) => {
  const { handleNext, uploadLink } = command
  const files = getState().visits.newVisit.notHealthyAutoParts.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('file', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(
          setNotHealthyAutoPartCancelToken({
            id: file.id,
            cancelToken: source,
          }),
        )
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'application/json',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setNotHealthyAutoPartUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        let newUploadLink = uploadLink
        if (newUploadLink == 'NEW_UPLOAD_LINK') {
          await HttpGetService({
            url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${command.data.sizeInKB}&VisitId=${command.data.visitId}`,
            onResult: (result: any) => {
              newUploadLink = result.data
            },
          })
        }
        if (newUploadLink != 'NEW_UPLOAD_LINK')
          await podInstance
            .post(`/files/${newUploadLink}`, formData, config)
            .then(res => {
              if (res.status == 200 && res.data.status == 200) {
                dispatch(
                  successNotHealthyAutoPartUploadFile({
                    id: file.id,
                    hashFile: res.data?.result?.hash,
                    hashFileType: res.data?.result?.type,
                    hashFileExtension: res.data?.result?.extension,
                    hashFileSize: res.data?.result?.size,
                  }),
                )
                return res.data
              } else dispatch(failureNotHealthyAutoPartUploadFile(file.id))
            })
            .catch(error => {
              if (
                getState().visits.newVisit.vehicleVisitingPoints.data.length &&
                getState().visits.newVisit.vehicleVisitingPoints.data.find(
                  (x: any) => x.id == file.id,
                )?.status != 3
              )
                dispatch(failureNotHealthyAutoPartUploadFile(file.id))
            })
      }
    }
    if (!getState().visits.newVisit.notHealthyAutoParts.data.some(x => x.status != 1) && handleNext)
      handleNext()
    return 1
  } catch (error) {
    console.error(error)
  }
})

export const uploadVehicleAccessoriesFilesPodSpace = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Visits/uploadVehicleAccessoriesFilesPodSpace', async (command, { getState, dispatch }) => {
  const { handleNext, uploadLink } = command
  const files = getState().visits.newVisit.vehicleAccessories.data.filter(x => x.status != 1)
  try {
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        let image = file.image.replace(`data:${file.fileType};base64,`, '')
        const imageBlob = base64ToBlob(image, file.fileType)

        let formData = new FormData()
        formData.append('file', imageBlob, `image.${file.fileType.replace('image/', '')}`)
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        dispatch(setVehicleAccessoryCancelToken({ id: file.id, cancelToken: source }))
        let config = {
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'application/json',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(
              setVehicleAccessoryUploadProgress({
                id: file.id,
                progress: percentageProgress,
              }),
            )
          },
        }
        let newUploadLink = uploadLink
        if (newUploadLink == 'NEW_UPLOAD_LINK') {
          await HttpGetService({
            url: `${VisitsApiPaths.GetUploadLink}?SizeInKB=${command.data.sizeInKB}&VisitId=${command.data.visitId}`,
            onResult: (result: any) => {
              newUploadLink = result.data
            },
          })
        }
        if (newUploadLink != 'NEW_UPLOAD_LINK')
          await podInstance
            .post(`/files/${newUploadLink}`, formData, config)
            .then(res => {
              if (res.status == 200 && res.data.status == 200) {
                dispatch(
                  successVehicleAccessoryUploadFile({
                    id: file.id,
                    hashFile: res.data?.result?.hash,
                    hashFileType: res.data?.result?.type,
                    hashFileExtension: res.data?.result?.extension,
                    hashFileSize: res.data?.result?.size,
                  }),
                )
                return res.data
              } else dispatch(failureVehicleAccessoryUploadFile(file.id))
            })
            .catch(error => {
              if (
                getState().visits.newVisit.vehicleVisitingPoints.data.length &&
                getState().visits.newVisit.vehicleVisitingPoints.data.find(
                  (x: any) => x.id == file.id,
                )?.status != 3
              )
                dispatch(failureVehicleAccessoryUploadFile(file.id))
            })
      }
    }
    if (!getState().visits.newVisit.vehicleAccessories.data.some(x => x.status != 1) && handleNext)
      handleNext()
    return 1
  } catch (error) {
    console.error(error)
  }
})

export const createVisit = createAsyncThunk('Visits/Create', async (command: any) => {
  const { data, navigate } = command

  let response: any
  await HttpPostService({
    url: VisitsApiPaths.CreateVisit,
    body: data,
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response) navigate(VisitsPaths.NewVisitFinalPage)
  return response
})

export const completePendingVisit = createAsyncThunk(
  'Visits/CompletePendingVisit',
  async (command: any) => {
    const { data, navigate } = command

    var response = await HttpPutService({
      url: VisitsApiPaths.CompletePendingVisit,
      body: data,
    })

    navigate(VisitsPaths.VisitsMain)

    return response
  },
)

export const UpdateVisitWithId = createAsyncThunk('Visit/UpdateVisit', async (command: any) => {
  const { data, navigate, t } = command

  let statusCode: number | undefined

  const response = await HttpPutService({
    url: VisitsApiPaths.UpdateVisit,
    body: data,
    onResult: (result: any) => {
      statusCode = result.status
    },
  })
  if (statusCode === 200) {
    setTimeout(() => {
      ToastCreateSuccessBottomLeft(t)
    }, 2000)
    navigate(VisitsPaths.VisitsMain)
  }

  return response
})

export const GetVisitForUpdate = createAsyncThunk(
  'Visit/GetVisitForUpdate',
  async (command: any) => {
    const { params } = command

    const response = await HttpGetService({
      url: VisitsApiPaths.GetVisitForUpdate,
      params: params,
    })

    return response
  },
)

export const GetAllPlateSerial = createAsyncThunk('PlateSerial/GetAllPlateSerial', async () => {
  var data = await getCache(CacheNames.FreeZone)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllPlateSerial,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.FreeZone, response)
  }

  return response
})

export const GetAllWithVehicleTypes = createAsyncThunk(
  'CargoCompartment/GetAllWithVehicleTypes',
  async () => {
    var data = await getCache(CacheNames.CargoRoom)
    if (data) return data

    let response: any
    await HttpGetService({
      url: VisitsApiPaths.GetAllWithVehicleTypes,
      params: {},
      onResult: (result: any) => {
        response = result.data
      },
    })

    if (response && response.length) {
      await setCache(CacheNames.CargoRoom, response)
    }

    return response
  },
)

export const GetVisitRequestPagedFilter = createAsyncThunk<any, any, { state: IApplicationState }>(
  'VisitRequest/GetVisitRequestPagedFilter',
  async (query, { getState }) => {
    return await HttpGetService({
      url: VisitsApiPaths.GetVisitRequestPagedFilter,
      params: {
        PlateType:
          query.plate?.type === 'UNDEFINED'
            ? 100
            : query.plate?.type === 'CAR'
              ? 1
              : query.plate?.type === 'FREEZONE'
                ? 3
                : 2,

        PlateCityCode: query.plate?.cityCode
          ? query.plate?.cityCode
          : query.plate?.serialPlate?.value,
        PlateChar: query.plate?.char ? query.plate?.char : null,
        PlateCarSerial: query.plate?.carSerial ? query.plate?.carSerial : null,
        PlateMotorCycleSerial: query.plate?.motorCycleSerial ? query.plate?.motorCycleSerial : null,
        PlateMotorCycleOtherNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : null,

        PlateSerialId: query.plate?.serialPlate?.id,

        PlateAdditionalNumber: query.plate?.motorCycleOtherNumber
          ? query.plate?.motorCycleOtherNumber
          : query.plate?.englishNumber,

        ChassisNumber: query.chassisNumber ? query.chassisNumber : null,
        EngineNumber: query.engineNumber ? query.engineNumber : null,
        FirstName: query.firstName ? query.firstName : null,
        LastName: query.lastName ? query.lastName : null,
        InsuranceTypeId: query.insuranceTypeId?.value,
        AssignedDraftVisitStatus: query.draftVisitStatus?.value,
        RegistrationDateFrom: query.visitStartDate,
        RegistrationDateTo: query.visitEndDate,
        PageNumber: query.pageNumber,
        PageSize: query.pageSize,
        NeedTotalCount: true,
      },
    })
  },
)

export const GetVisitRequestById = createAsyncThunk<any, any, { state: IApplicationState }>(
  'VisitRequest/GetVisitRequestById',
  async VisitRequestId => {
    return await HttpGetService({
      url: VisitsApiPaths.GetVisitRequestById,
      params: {
        VisitRequestId,
      },
    })
  },
)

export const GetVisitRequestByNotificationId = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('VisitRequest/GetVisitRequestByNotificationId', async (NotificationId: number) => {
  return await HttpGetService({
    url: VisitsApiPaths.GetVisitRequestByNotificationId,
    params: {
      NotificationId,
    },
  })
})

export const SetAssignVisitRequestCancelledByExpert = createAsyncThunk(
  'VisitRequest/SetAssignVisitRequestCancelledByExpert',
  async (command: any) => {
    const { data, navigate, t } = command

    let statusCode: number | undefined

    const response = await HttpPutService({
      url: VisitsApiPaths.SetAssignVisitRequestCancelledByExpert,
      body: data,
      onResult: (result: any) => {
        statusCode = result.status
      },
    })
    if (statusCode === 200) {
      setTimeout(() => {
        ToastCreateSuccessBottomLeft(t)
      }, 2000)
      navigate(VisitsPaths.VisitsMain)
    }

    return response
  },
)

export const SetAssignVisitRequestRejected = createAsyncThunk(
  'VisitRequest/SetAssignVisitRequestRejected',
  async (command: {
    data: { visitRequestId: number; description: string }
    navigate: NavigateFunction
    t: string
  }) => {
    const { data, navigate, t } = command

    let statusCode: number | undefined

    const response = await HttpPutService({
      url: VisitsApiPaths.SetAssignVisitRequestRejected,
      body: data,
      onResult: (result: any) => {
        statusCode = result.status
      },
    })
    if (statusCode === 200) {
      setTimeout(() => {
        ToastCreateSuccessBottomLeft(t)
      }, 2000)
      navigate('/Notification')
    }

    return response
  },
)
export const SetAssignVisitRequestAccepted = createAsyncThunk(
  'VisitRequest/SetAssignVisitRequestAccepted',
  async (command: {
    data: { visitRequestId: number; visitDate: string }
    navigate: NavigateFunction
    t: string
  }) => {
    const { data, navigate, t } = command

    let statusCode: number | undefined

    const response = await HttpPutService({
      url: VisitsApiPaths.SetAssignVisitRequestAccepted,
      body: data,
      onResult: (result: any) => {
        statusCode = result.status
      },
    })
    if (statusCode === 200) {
      setTimeout(() => {
        ToastCreateSuccessBottomLeft(t)
      }, 2000)
      navigate('/Visits?tab=2')
    }

    return response
  },
)

export const getInsuranceExpertFieldsPagedFilter = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('Expert/GetInsuranceExpertFieldPagedFilter', async (query, { getState }) => {
  const { currentPage, customPageSize } = getState().visits.IInsuranceExpertFieldsState.pagination
  const queryString = QueryStringBuilder({
    ...query,
    pageNumber: currentPage,
    pageSize: customPageSize,
    needTotalCount: true,
  })
  return await HttpGetService({
    url: `${VisitsApiPaths.GetInsuranceExpertFieldsPagedFilter}?${queryString}`,
  })
})

export const GetExpertsInsuranceUnitById = createAsyncThunk(
  'InsuranceUnit/GetExpertsInsuranceUnitById',
  async (id: number) => {
    return await HttpGetService({
      url: `${VisitsApiPaths.GetExpertsRIVInsuranceUnitById}${id}`,
    })
  },
)

export const getInsuranceUnitsPagedFilter = createAsyncThunk<
  any,
  any,
  { state: IApplicationState }
>('InsuranceUnit/GetInsuranceUnitsPagedFilter', async (query, { getState }) => {
  const { currentPage, customPageSize } = getState().visits.insuranceUnits.pagination

  return await HttpGetService({
    url: VisitsApiPaths.GetRIVInsuranceUnitsPagedFilter,
    params: {
      ...query,
      pageNumber: currentPage,
      pageSize: customPageSize,
      needTotalCount: true,
    },
  })
})

export const ReferDraftVisitByExpert = createAsyncThunk(
  'DraftVisit/ReferDraftVisitByExpert',
  async (command: any) => {
    const { data, t, navigate } = command
    let statusCode: number | undefined
    const response = await HttpPutService({
      url: VisitsApiPaths.ReferDraftVisitByExpert,
      body: data,
      onResult: (result: any) => {
        statusCode = result.status
      },
    })
    if (statusCode === 200) {
      setTimeout(() => {
        navigate(-1)
      }, 2000)
    }
    return response
  },
)

// export const GetAllCountry = createAsyncThunk<any, any, { state: IApplicationState }>(
//   'Country/GetCountryPagedFilter',
//   async () => {
//     return await HttpGetService({
//       url: VisitsApiPaths.GetAllCountry,
//       // params: {
//       //   needTotalCount: true,
//       // },
//     })
//   },
// )

export const GetAllCountry = createAsyncThunk('Country/GetCountryPagedFilter', async () => {
  var data = await getCache(CacheNames.Country)
  if (data) return data

  let response: any
  await HttpGetService({
    url: VisitsApiPaths.GetAllCountry,
    params: {},
    onResult: (result: any) => {
      response = result.data
    },
  })

  if (response && response.length) {
    await setCache(CacheNames.Country, response)
  }

  return response
})
